import React, { useState, useEffect } from 'react';
import { Form, Select, Typography, Radio, Row, Col } from 'antd';

const { Option } = Select;
const { Text } = Typography;

const PotentialMetrices = ({ ability, aspiration, adaptability, onAbilityChange, onAspirationChange, onAdapatabilityChange }) => {

  const [selectedValues, setSelectedValues] = useState([]);
  const [average, setAverage] = useState(null);

  //console.log('Ability:', ability);

  useEffect(() => {
    /* console.log('ability:', ability);
    console.log('aspiration:', aspiration);
    console.log('adaptability:', adaptability);
 */

    // Calculate the average whenever selectedValues changes
    const numericValues = Object.values(selectedValues).map((value) => parseFloat(value));

    const validNumericValues = numericValues.filter((value) => !isNaN(value));

    if (validNumericValues.length > 0) {
      const sum = validNumericValues.reduce((acc, currentValue) => acc + currentValue, 0);
      const averageValue = sum / validNumericValues.length;
      setAverage(averageValue);
    } else {
      setAverage(null);
    }
  }, [selectedValues]);

  const handleSelectChange = (dropdownName, value) => {
    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [dropdownName]: value,
    }));
  };



  const [selectedValue, setSelectedValue] = useState('');

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleAbilityChange = (value) => {
    onAbilityChange(value); // Call the change handler passed from AssessmentPage
  };



  return (
    <div>


      <Form
        name="ant_design_dropdown_form"

      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >
          <h2>Potential</h2>
          <Text italic>
            (Note : Editable for Calibration)
          </Text>
        </div>
        <Row gutter={[50, 50]}>
          <Col>
            <Form.Item label="Ability" style={{ fontWeight: 'bold' }} name="poability" rules={[{ required: true, message: 'Please select an option!' }]}>
              <Select value={ability} onChange={onAbilityChange} style={{ width: '280px', fontSize: '10px' }} placeholder="Select an option" >
                <Option value="5">Eager to Expand</Option>
                <Option value="4">Ready for More</Option>
                <Option value="3">Successful</Option>
                <Option value="2">Maxed Out</Option>
                <Option value="1">Inconsistent</Option>
              </Select>
              <Text style={{ fontSize: 12 }}></Text>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Aspiration" style={{ fontWeight: 'bold' }} name="poaspiration" rules={[{ required: true, message: 'Please select an option!' }]}>
              <Select value={aspiration} onChange={onAspirationChange} style={{ width: '300px', fontSize: '10px' }} placeholder="Select an option" >
                <Option value="5">Eager to Expand</Option>
                <Option value="4">Ready for More</Option>
                <Option value="3">Successful</Option>
                <Option value="2">Maxed Out</Option>
                <Option value="1">Inconsistent</Option>
              </Select>
              <Text style={{ fontSize: 12 }}></Text>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Engagement" style={{ fontWeight: 'bold' }} name="poengage" rules={[{ required: true, message: 'Please select an option!' }]}>
              <Select value={adaptability} onChange={onAdapatabilityChange} style={{ width: '300px', fontSize: '10px' }} placeholder="Select an option" >
                <Option value="5">Eager to Expand</Option>
                <Option value="4">Ready for More</Option>
                <Option value="3">Successful</Option>
                <Option value="2">Maxed Out</Option>
                <Option value="1">Inconsistent</Option>
              </Select>
              <Text style={{ fontSize: 12 }}></Text>
            </Form.Item>
          </Col>
        </Row>




      </Form>




    </div>
  );
};

export default PotentialMetrices;